import React from 'react';
import { Box } from '@mui/material';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { useTranslation } from 'react-i18next';
import { SttButton, SttPage } from '../../../sporttia/all';
import { useCloseToPreviousPage } from '../../../lib/hooks/useCloseToPreviousPage';
import SalePointBody from './SalePointBody';
import { useSalePoint } from './useSalePoint';

/**
 * Punto de venta con su propia URL: una página del gestor, con el sidebar y la
 * cabecera compartida, para que se pueda abrir en otra pestaña o ventana y
 * ocupe la pantalla completa. La flecha de la cabecera vuelve a donde se
 * estaba, o al cuadrante si se entró directamente por la URL.
 */
export default function SalePointPage(): React.ReactElement {
    const { t } = useTranslation();
    const close = useCloseToPreviousPage();
    const salePoint = useSalePoint({ idTicket: 'create', onClose: close });

    const canPrint =
        !!salePoint.previousPurchaseTicket &&
        salePoint.previousPurchaseTicket?.status === 'CLOSE';

    return (
        <SttPage title={t('PointOfSale')} onBack={salePoint.requestClose}>
            {canPrint && (
                <Box className="mb-4 flex flex-wrap justify-end gap-2">
                    <SttButton
                        caption={t('Print')}
                        onClick={() => salePoint.downloadTicket()}
                        icon={<ConfirmationNumberIcon />}
                    />
                </Box>
            )}

            <SalePointBody salePoint={salePoint} />
        </SttPage>
    );
}
